import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { BaseComponent } from 'src/app/framework/components/base.component';
import { ConsumersService } from '../../../consumers.service';

@Component({
  selector: 'app-edit-promocode-history',
  templateUrl: './edit-promocode-history.component.html',
  styleUrls: ['./edit-promocode-history.component.scss']
})
export class EditPromocodeHistoryComponent extends FeaturesBaseComponent implements OnInit {
  validityEditForm: FormGroup;
  promocodeId: any;
  validityFormData: any;
  endDate:any;
  constructor(private fb: FormBuilder,private consumersService: ConsumersService, public dialogRef: MatDialogRef<EditPromocodeHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      super();
      this.validityFormData = data;
      this.validityEditForm = new FormGroup({
        promocodeEndDateTime: new FormControl('')
      })
      this.endDate = moment(this.validityFormData.promocodeEndDateTime).utc().format('YYYY-MM-DD');
      // this.validityEditForm.get('promocodeEndDateTime').setValue(this.endDate)
     }
     

  ngOnInit(): void {
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  get ar(){ 
    return this.validityEditForm.controls
    }

  get f() {
    return this.validityEditForm.controls;
  }

  checkSubmitDisplayed() {
    return !(this.validityEditForm.valid && !this.validityEditForm.pristine); 
  }
  onUpdatePromoValidity() {
    let promocodeEnddttm =  moment(this.validityEditForm.get('promocodeEndDateTime').value).format('MM-DD-YYYY');
       let promoId=this.validityFormData.promocodeId;


        this.consumersService.updatePromocodeValidity(promoId,promocodeEnddttm).subscribe(
          res => {
            if (res['httpcode'] == 200) {
              this.toastrService.success('Promocode validity changed successfully')
            }
          }, err => {
            console.log(err.error);
            this.toastrService.error(err.error.userMessage)
          }
        );
        this.onCancel();
      }
}



